<template>
  <div class="game-selection default-bg">
    <top-navigation></top-navigation>
    <div class="content container-fluid middle">
      <h1 class="text-center">CHOOSE YOUR GAME</h1>
      <div class="row selection">
        <div class="col-4">
          <router-link to="hide-and-seek">
            <img src="../assets/img/hide-and-seek.jpg"/>
            <h1>HIDE AND SEEK</h1>
          </router-link>
        </div>
        <div class="col-4">
          <router-link to="true-or-false">
            <img src="../assets/img/true-or-false.jpg"/>
            <h1>TRUE OR FALSE</h1>
          </router-link>
        </div>
        <div class="col-4">
          <router-link to="now-you-see-me">
            <img src="../assets/img/now-you-see-me.jpg"/>
            <h1>NOW YOU SEE ME</h1>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from '../components/TopNavigation'
import { mapGetters } from 'vuex'

export default {
  components: {
    TopNavigation
  },
  name: 'GameSelection',
  computed: {
    ...mapGetters(['avatar'])
  }
}
</script>

<style scoped>
  .content {
    text-align: center;
    color: #ffffff;
    height: 70vh;
  }

  .selection {
    padding-top: 30px;
  }

  .game-selection h1 {
    font-family: "Geograph-Black";
    color: #feca33;
    padding-top: 14pt;
    font-size: 4.5vw;
  }

  .selection h1 {
    color: #fff;
    font-family: "Geograph-Black";
    font-size: 4vh;
  }

  .selection img {
    max-height: 40vh;
    max-width: 100%;
  }
</style>
